<template>
    <div>
        <ul class="cloud-plan-list">
            <li v-for="(subscribe, index) of showingSubscribes"
                :key="index"
                :style="{
                    borderColor: subscribe.plan.style['plan.display_color'],
                }"
            >
                <Card
                    :subscribe="subscribe"
                    :cloudProductLists="cloudProductLists"
                    :is-active-plans="isActivePlans"
                    @showChangeSubNameDialog="showChangeSubNameDialog"
                    @showSubDevices="showSubDevices"
                    @refresh="$emit('refresh')"
                />
            </li>
        </ul>
        <reo-dialog
            :labelOfCancel="$t('dialog.cancel')"
            :labelOfConfirm="$t('dialog.save')"
            class="changeSubNameDialog"
            ref="subNameDialog"
            v-if="isShowChangeSubNameDialog"
            @confirm="changeSubName"
            @cancel="isShowChangeSubNameDialog = false;subName = '';">
            <template v-slot:changeSubName>
                <div class="changeSubName">
                    <p class="title">
                        {{ $t("dashboard.changeSubNameTitle") }}
                    </p>
                    <input v-model="subName" type="text" class="ui-input" />
                    <p v-if="changeSubNameError" style="color: red; margin-top: 0.1rem">
                        {{ changeSubNameError }}
                    </p>
                </div>
            </template>
        </reo-dialog>
        <reo-dialog
            class="selectProduct"
            :title="selectDeviceDialogTitle"
            :labelOfConfirm="$t('dialog.save')"
            :showButton="!selectProductEmpty"
            isBottomWhenMobile
            use-action-footer
            :key="dialogStack.length"
            v-if="isSelectDevices"
            ref="changeAssociatedDialog"
            @confirm="changeAssociated"
            @cancel="restoreDevicesList">
            <select-product
                tableLoc="select"
                :key="'selectProduct'"
                @selectedDevicesChange="handleDevices"
                :selectedDevices="selectedDevices"
                :deviceData="deviceData"
                :selectLimit="planVideoQuantity"
                :availableModel="availableModel"
                :subId="sub?.subId"
                :deviceAssociateResults="deviceAssociateResults"
                sticky-header
                @emptyStateChange="selectProductEmpty = $event"
            >
            </select-product>
        </reo-dialog>
        <see-more @showMore="showMore" :haveMore="haveMore"></see-more>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import SelectProduct from '@/components/selectProduct.vue';
import { changeSubName, changeAssociate } from '@/api/cloud';
import { unfoldError } from '@/common/js/notice';
import { config } from 'CONFIG';
import { mapGetters } from 'vuex';
import { EAssociateFailedReason, IDeviceAssociationResultItem } from '@reolink-cloud/interface';
import Card from './SubCard.vue';
import { ISubscribeData } from './types';
import seeMore from '@/basic/seeMore.vue';

const MORE_STEP = 10;
const DEFAULT_SUB_INDEX = 2;

export default Vue.extend({
    components: {
        ReoDialog,
        SelectProduct,
        Card,
        seeMore
    },
    props: {
        subscribes: Array as PropType<any[]>,
        deviceList: Array,
        cloudProductLists: Object,
        isActivePlans: Boolean
    },
    data () {

        return {
            config,
            sub: null as null | Record<string, any>,
            subName: '',
            showRenewBtn: true,
            isShowChangeSubNameDialog: false,
            changeSubNameError: false as boolean | string,
            isSelectDevices: false,
            hadSelect: 0,
            dialogStack: [] as any[],
            editingSub: {} as Record<string, any>,
            selectedDevices: [] as any[],
            usageString: [] as any[],
            allUsedSpace: 0,
            subDeviceDataShow: [] as any[],
            deviceData: [] as any[],
            availableModel: [] as any[],
            planVideoQuantity: 0,
            subIndex: DEFAULT_SUB_INDEX,
            flag: false,
            deviceAssociateResults: {} as Record<string, IDeviceAssociationResultItem>,
            selectProductEmpty: false
        };

    },
    methods: {
        showChangeSubNameDialog ( sub ): void {

            this.isShowChangeSubNameDialog = true;
            this.editingSub = sub;
            this.subName = sub.title || sub.planTitle;

        },
        async changeSubName (): Promise<void> {

            if ( this.subName.length <= 40 && this.subName.length > 0 ) {

                this.changeSubNameError = false;
                try {

                    await changeSubName( this.editingSub.subId, this.subName );
                    this.$emit( 'refresh' );
                    this.subName = '';
                    this.isShowChangeSubNameDialog = false;

                } catch ( err ) {

                    console.log( err );
                    this.changeSubNameError = this.$tc( 'errors.server_error' );
                    unfoldError( 'errors.server_error', 10000 );

                }

            } else {

                this.changeSubNameError = `Subscription's name must shorter than 40 characters or greated than 0 character`;

            }

        },

        deviceDiff (): { associate: any[];unassociate: any[]; } {

            let oldSelected = this.editingSub.deviceList.map( item => {

                return item.uid;

            });
            let newSelected = this.selectedDevices.map( item => {

                return item.uid;

            });
            // 求差集
            let difference = oldSelected.concat( newSelected ).filter( v => !newSelected.includes( v ) || !oldSelected.includes( v ));
            // 遍历oldselected，不存在则为新增
            // 遍历newselected，不存在则为减少
            let associate: any[] = [];
            let unassociate: any[] = [];
            for ( let item of difference ) {

                if ( oldSelected.indexOf( item ) === -1 ) {

                    for ( let obj of this.selectedDevices ) {

                        if ( item === obj.uid ) {

                            associate.push({ uid: obj.uid });

                        }

                    }

                }

                if ( !newSelected.includes( item )) {

                    for ( let obj of this.editingSub.deviceList ) {

                        if ( item === obj.uid ) {

                            unassociate.push({ uid: obj.uid });

                        }

                    }

                }

            }

            return { associate, unassociate };

        },
        // 部分绑定或解绑失败后，更新或重置选中状态
        restoreFailedDeviceSelection (
            deviceResults: Record<string, IDeviceAssociationResultItem>
        ): void {

            const selectedUidSet = new Set( this.selectedDevices.map( item => item.uid ));

            for ( const [uid, result] of Object.entries( deviceResults )) {

                if ( result.status !== 'failed' ) {

                    continue;

                }

                if ( result.type === 'unassociate' ) {

                    const originalDevice = this.editingSub.deviceList.find( item => item.uid === uid );
                    if ( originalDevice && !selectedUidSet.has( uid )) {

                        this.selectedDevices.push( originalDevice );
                        selectedUidSet.add( uid );

                    }

                }

                if ( result.type === 'associate' ) {

                    this.selectedDevices = this.selectedDevices.filter( item => item.uid !== uid );
                    selectedUidSet.delete( uid );

                }

            }

            this.hadSelect = this.selectedDevices.length;

        },

        async changeAssociated (): Promise<void> {

            const { associate, unassociate } = this.deviceDiff();
            const subscriptionId = this.editingSub.subId;
            const affectedUids = [
                ...associate.map( item => item.uid ),
                ...unassociate.map( item => item.uid )
            ];

            const unassociateDevices = unassociate.map( item => ({
                subscription: subscriptionId,
                uid: item.uid
            }));
            const associateDevices = associate.map( item => ({
                subscription: subscriptionId,
                uid: item.uid
            }));

            try {

                if ( affectedUids.length === 0 ) {

                    this.$emit( 'refresh' );
                    this.isSelectDevices = false;
                    return;

                }

                const { deviceResults } = await changeAssociate({
                    associateDevices,
                    unassociateDevices
                });

                this.deviceAssociateResults = deviceResults;
                this.restoreFailedDeviceSelection( deviceResults );

                const isAllSuccess = affectedUids.every( uid => deviceResults[uid]?.status === 'success' );
                if ( isAllSuccess ) {

                    this.$emit( 'refresh' );
                    this.isSelectDevices = false;
                    this.deviceAssociateResults = {};

                }

            } catch ( err ) {

                console.log( err );
                const deviceResults: Record<string, IDeviceAssociationResultItem> = {};
                for ( const item of unassociate ) {

                    deviceResults[item.uid] = {
                        status: 'failed',
                        type: 'unassociate',
                        reason: EAssociateFailedReason.OTHER
                    };

                }

                for ( const item of associate ) {

                    deviceResults[item.uid] = {
                        status: 'failed',
                        type: 'associate',
                        reason: EAssociateFailedReason.OTHER
                    };

                }
                this.deviceAssociateResults = deviceResults;
                this.restoreFailedDeviceSelection( deviceResults );

            }

        },

        showSubDevices ( sub ): void {

            if ( typeof sub !== 'undefined' ) {

                this.sub = sub;

            }
            this.deviceAssociateResults = {};
            this.selectProductEmpty = false;
            this.isSelectDevices = true;
            this.planVideoQuantity = this.sub!.maxCamera;
            // ! deviceData为全部设备
            // ! selectedDevices 为订阅中已关联的设备
            this.selectedDevices = JSON.parse( JSON.stringify( this.sub!.deviceList ));
            this.subDeviceDataShow = JSON.parse( JSON.stringify( this.sub!.deviceList ));
            this.deviceData = JSON.parse( JSON.stringify( this.deviceList ));
            this.editingSub = this.sub!;
            this.availableModel = this.sub!.availableModel;

        },

        handleDevices ( newVal ): void {

            this.selectedDevices = newVal;
            this.hadSelect = newVal.length;

        },

        restoreDevicesList (): void {

            this.isSelectDevices = false;
            this.deviceAssociateResults = {};
            this.selectProductEmpty = false;
            this.hadSelect = 0;
            this.subDeviceDataShow = JSON.parse( JSON.stringify( this.sub!.deviceList ));
            this.selectedDevices = JSON.parse( JSON.stringify( this.sub!.deviceList ));
            this.deviceData = JSON.parse( JSON.stringify( this.deviceList ));

        },

        dialogMounted ( ref ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }
            this.dialogStack.push( ref );

        },

        dialogDestroyed (): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }

        },

        showMore (): void {

            this.subIndex += MORE_STEP;

        },

    },
    computed: {
        ...mapGetters( ['isMobile', 'lang'] as const ),
        showingSubscribes(): ISubscribeData[] {

            return this.subscribes.slice( 0, this.subIndex );

        },
        haveMore(): boolean {

            return this.subIndex < this.subscribes.length;

        },
        selectDeviceDialogTitle(): string {

            return `${this.$t( 'selectProduct.title' ).toString()} (${this.hadSelect}/${this.planVideoQuantity})`;

        },

    },
    watch: {
        subscribes: {
            handler ( list: unknown[] ): void {

                const len = list?.length ?? 0;
                if ( len === 0 ) {

                    this.subIndex = DEFAULT_SUB_INDEX;
                    return;

                }
                // Keep expanded count after list refresh; clamp to list length
                this.subIndex = Math.min(
                    Math.max( this.subIndex, DEFAULT_SUB_INDEX ),
                    len
                );

            },
            immediate: true
        },
        isActivePlans (): void {

            this.subIndex = DEFAULT_SUB_INDEX;

        },
        deviceList: {
            handler ( ): void {

                if ( this.$route.query.planId ) {

                    const planId = this.$route.query.planId as string;
                    const subId = this.$route.query.s_id as string;
                    const subscribe = this.subscribes.find(( i ) => {

                        if ( subId ) {

                            return i.subId === subId;

                        } else {

                            return i.plan.id === planId;

                        }

                    });

                    if ( subscribe && !this.flag ) {

                        this.showSubDevices( subscribe );
                        this.isSelectDevices = true;
                        this.flag = true;

                    }

                }

            }
        }
    },
});
</script>

<style lang='less' scoped>
    .changeSubNameDialog{
        /deep/ .changeSubName{
            box-sizing: border-box;
            text-align: left;
            color:#333333;
        }
        /deep/ .reo-dialog-inner .btnBox{
            display: flex;
            justify-content: flex-end;
            button.cancel-button,
            button.confirm-button{
                font-family: @font_02;
                font-weight: 500;
                min-width: 0;
            }
        }
        @media @pc{

            /deep/ .changeSubName{

                margin-top: .4rem;
                font-size: .16rem;
                line-height: 1.6;
                .title{
                    font-weight: 500;
                    margin-bottom: .2rem;
                }
                input.ui-input{
                    width:100%
                }
            }
            /deep/ .reo-dialog-inner {

                min-height: unset !important;
                .btnBox{
                    padding:0 .4rem;
                    button.cancel-button,
                    button.confirm-button{
                        font-size: .14rem;
                        line-height: .38rem;
                    }
                    button.cancel-button{
                        padding:0 .18rem;
                    }
                    button.cancel-button:hover{
                        line-height: .4rem;
                    }
                    button.confirm-button{
                        padding:0 .265rem;
                    }
                }
            }
        }
        @media @mobile{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            /deep/ .reo-dialog-inner{
                bottom: unset !important;
                margin:0 .3rem !important;
                border-radius: 20px !important;
                .close{
                    transform: translate(50%, -50%) !important;
                }
            }
            /deep/ .changeSubName{

                width:100%;
                padding:0 .3rem;
                margin-top: .56rem;
                font-size: .26rem;
                line-height: 1.6;
                .title{
                    font-weight: 500;
                    margin-bottom: .3rem;
                }

                input.ui-input{
                    width:100%;
                    margin-bottom:0;
                    padding:.21rem .30rem;
                }
            }
            /deep/ .reo-dialog-inner .btnBox{
                padding:0 .4rem;
                margin-bottom: .48rem !important;
                button.cancel-button,
                button.confirm-button{
                    font-size: .24rem;
                    line-height: .6rem;
                }
                button.cancel-button{
                    padding:0 .30rem;
                    margin-right: .24rem !important;
                }
                button.cancel-button:hover{
                    line-height: .62rem;
                }
                button.confirm-button{
                    padding:0 .42rem;
                    margin-top: 0;
                }
            }
        }
    }
    .associatedDevices{
        @media @pc{
            /deep/ .reo-dialog-inner {
                padding-bottom: .5rem;
                min-width: 8.82rem;
                min-height: 3rem !important;
                .btnBox{
                    margin: 0 !important;
                }
            }
            /deep/ .icon-icon_edit{
                font-size: .24rem;
                margin-left:.1rem;
            }
        }
        @media @mobile{
            /deep/ .reo-dialog-inner {
                padding-bottom: .8rem;
                .btnBox{
                    margin: 0 !important;
                }
                .scroll-context{
                    padding-left: 0 !important;
                }
            }
            /deep/ .icon-icon_edit{
                font-size: .42rem;
                margin-left:.2rem;
            }
        }
        /deep/ .icon-icon_edit{

            cursor: pointer;
            color: @theme;
        }

    }
    .tabBox{
        display: flex;
        border-bottom: 1px solid #ccc;
        margin-bottom: .24rem;
        width: fit-content;
        @media @mobile{
            margin:0 .3rem .3rem;
            width:4.82rem;
        }
        .tabItem{
            font-size: .16rem;
            line-height: 1.2;
            font-family: @font_02;
            font-weight: 500;
            color:#777;
            padding-bottom: .1rem;
            opacity: .85;
            cursor:pointer;
            @media @mobile{
                font-size: .26rem;
            }
            &:nth-child(1){
                margin-right: .4rem;
                @media @mobile{
                    margin-right: .56rem;
                }
            }
            &.active{
                color:@theme;
                border-bottom: 3px solid @theme;
            }
        }
    }
    .plans{
        & /deep/ .tip-icon{
            font-size: .16rem;
            @media @mobile{
                font-size: .28rem;
                width: unset !important;
                height: unset !important;
            }

        }
    }
    .reo-dialog.selectProduct{
        .select-product-dialog();
    }
    .reo-dialog.associatedDevices{
        @media @pc{
            /deep/ .reo-dialog-inner{
                max-width: unset;
            }
        }
    }
.cloud-plan-list {
    font-size: 0.16rem;
    margin-bottom: 0.3rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: auto auto;
    gap: 16px;
    position: relative;

    .mobile({
        grid-template-columns: 1fr;
        grid-auto-rows: unset;
    });
    &>li {
        width: 100%;
        border-radius: 8px;
        box-sizing: border-box;
        text-align: center;
        background-color: @bg_02;
        position: relative;
        display: grid;
        grid-template-rows: subgrid;
        grid-row: span 2;
    }
}

</style>
